// Turkish
export const tr = {
    weeklyRewards: 'Haftalık ödüllere kalan',
    days: 'gün',
    hours: 'saat',
    minutes: 'dk',
    seconds: 'sn',
    authenticating: 'Doğrulanıyor',
    verifyWallet: 'Lütfen cüzdanınızı doğrularken bekleyin',
    authRequired: 'Doğrulama gerekli',
    authFailed: 'Doğrulama başarısız. Lütfen tekrar deneyin.',
    points: 'Puan',
    rank: 'Sıralama',
    of: '/',
    players: 'oyuncu',
    weeklyTopPlayers: 'Haftanın en iyi oyuncuları',
    thisWeekLeaderboard: 'Bu haftanın sıralaması',
    rankingsReset: 'Sıralama her Pazar UTC gece yarısında sıfırlanır',
    yourPoints: 'Puanlarınız',
    dailyRewardAvailable: 'Günlük ödül mevcut!',
    nextClaimAvailable: 'Sonraki talep şu kadar sürede mevcut:',
    claimDailyReward: 'Günlük ödülü al',
    claiming: 'Alınıyor...',
    multiplier: 'Çarpan',
    bonusPointsMultiplier: 'Bonus puan çarpanı',
    outOf: '/',
    loading: 'Yükleniyor...',
    errorLoading: 'Yükleme hatası',
    noEntries: 'Kayıt yok',
    leaderboard: 'Sıralama',
    tasks: 'Görevler',
    rules: 'Kurallar',
    profile: 'Profil',
    comingSoon: 'Yakında...',
    completedTasks: 'Tamamlanan görevler',
    dailyRewardsClaimed: 'Alınan günlük ödüller',
    times: 'kez',
    recentActivity: 'Son aktivite',
    noRewardsClaimed: 'Henüz ödül alınmadı',
    dailyReward: 'Günlük ödül',
    howItWorks: 'Nasıl çalışır',
    welcomeMessage:
        "Coinomi Rewards'a hoş geldiniz! Çeşitli görevleri tamamlayarak puan kazanın ve sıralamada yükselin.",
    dailyRewardsTitle: 'Günlük ödüller',
    dailyRewardsRules: [
        'Her 24 saatte bir günlük ödülünüzü alın',
        'Her talep 100 puan değerindedir',
        'Puanlar çarpanınızla çarpılır',
    ],
    multiplierBonusesTitle: 'Çarpan bonusları',
    multiplierBonusesRules: [
        '1x çarpanla başlayın',
        'Telegram bağlantısı için +10% bonus',
        'E-posta doğrulaması için +10% bonus',
        'Maksimum ödül için bonuslar birikir',
    ],
    leaderboardTitle: 'Sıralama',
    leaderboardRules: [
        'Diğer oyuncularla rekabet edin',
        'Sıralama gerçek zamanlı güncellenir',
        'En iyi oyuncular özel ödüller alır',
    ],
    boostEarningsTitle: 'Kazançlarınızı artırın',
    boostEarningsRules: [
        'Bonuslar için görevleri tamamlayın',
        'Telegram topluluğumuza katılın',
        'Maksimum ödül için aktif kalın',
    ],
    challenges: 'Görevler',
    telegramChallenge: 'Telegram görevi',
    emailChallenge: 'E-posta görevi',
    connectTelegram: "Telegram'ı bağla",
    shareEmail: 'E-posta paylaş',
    telegramSuccess: '🎉 Tebrikler! Artık tüm ödüllerde kalıcı %10 bonus alıyorsunuz!',
    telegramPrompt: 'Tüm ödüllerde kalıcı %10 bonus almak için Telegram hesabınızı bağlayın!',
    emailSuccess: '🎉 Tebrikler! Artık tüm ödüllerde kalıcı %10 bonus alıyorsunuz!',
    emailPrompt: 'Tüm ödüllerde kalıcı %10 bonus almak için e-postanızı paylaşın!',
    connectEmail: 'E-posta bağla',
    cancel: 'İptal',
    emailPrivacy: 'E-postanızı sadece önemli güncellemeler ve ödül bildirimleri için kullanıyoruz.',
    connectYourEmail: 'E-postanızı bağlayın',
    emailBonus: '🎉 E-postanızı bağlayarak tüm ödüllerde kalıcı %10 bonus alın!',
    enterValidEmail: 'Lütfen geçerli bir e-posta adresi girin',
    emailAddress: 'E-posta adresi',
    errorSavingEmail: 'E-posta kaydedilirken hata oluştu. Lütfen tekrar deneyin.',
    claimButton: 'Al',
    earnedReward: 'Kazanılan ödül',
    rewardValue: '{{amount}} Puan',
    claimingReward: 'Alınıyor...',
    claimSuccess: 'Başarıyla {{amount}} puan alındı!',
    claimError: 'Alma başarısız. Lütfen tekrar deneyin.',
    privacyDisclaimer:
        'Coinomi kişisel veri toplamaz; üçüncü parti bir sistem puanları ve sosyal bağlantıları güvenli şekilde yönetir.',
    streakBonus: 'Seri bonusu',
    streakDays: '{{days}}/5 Gün',
    streakBonusValue: '+%{{percent}}',
    streakMaxBonus: '+%10 Ekstra',
    streakDescription: 'Maksimum bonus için 5 gün üst üste alın',
    streakToday: 'Bugün',
    streakMissed: 'Kaçırıldı',
    streakComplete: 'Tamamlandı',
    streakActive: 'Aktif seri',
    streakLost: 'Seri kaybedildi',
    streakNext: 'Sonraki',
    home: 'Ana sayfa',
    currentStreak: 'Mevcut seri',
    totalClaims: 'Toplam alım',
    userStats: 'İstatistikleriniz',
    referrals: 'Referanslar',
    referralProgram: 'Referans programı',
    howReferralWorks: 'Referanslar nasıl çalışır:',
    referralSteps: [
        'Referans bağlantınızı arkadaşlarınızla paylaşın',
        'Bağlantınız üzerinden katıldıklarında referansınız olurlar',
        'Her aktif referans için bonus puan kazanın',
        'Referanslarınızı ve kazançlarınızı buradan takip edin',
    ],
    referralRewards: 'Verilen referans puanları:',
    referralBonuses: [
        'Referans başına 100 puan',
        "Referanslarınızın kazandığı tüm puanların %10'u",
    ],
    yourReferralLink: 'Referans bağlantınız',
    copyToClipboard: 'Panoya kopyala',
    linkCopied: 'Bağlantı panoya kopyalandı!',
    totalReferrals: 'Toplam referans',
    yourReferralCode: 'Referans kodunuz',
    referralCodeCopied: 'Referans kodu kopyalandı!',
    editReferralCode: 'Referans kodunu düzenle',
    editReferralCodeInstructions:
        'Yeni bir referans kodu seçin. En az 5 karakter olmalı ve harf ve rakam içerebilir.',
    newReferralCode: 'Yeni referans kodu',
    referralCodeRequirements: 'En az 5 karakter, sadece harf ve rakam',
    updating: 'Güncelleniyor...',
    update: 'Güncelle',
    referralCodeTaken: 'Bu referans kodu zaten kullanımda',
    haveReferralCode: 'Referans kodunuz var mı?',
    enterReferralCodePrompt:
        'Sizi biri referans ettiyse, hesapları bağlamak için kodlarını buraya girin.',
    enterReferralCode: 'Referans kodu girin',
    enterReferralCodeInstructions: 'Size paylaşılan referans kodunu girin.',
    referralCode: 'Referans kodu',
    referralCodeFormat: 'Sadece harf ve rakam',
    submitting: 'Gönderiliyor...',
    submit: 'Gönder',
    enterCode: 'Kod girin',
    pleaseAddtoken: "Lütfen URL'ye token parametresini ekleyin",
    authenticationError: 'Doğrulama sırasında bir hata oluştu',
    noUserFound: 'Kullanıcı bulunamadı',
    userNotFoundMessage: 'Kullanıcı verileri bulunamadı',
    backToHome: 'Ana sayfaya dön',
    retry: 'Tekrar dene',
    baseMultiplier: 'Temel çarpan',
    telegramBonus: 'Telegram bonusu',
    referralChallenge: 'Referans görevi',
    referralChallengePrompt:
        "Arkadaşlarınızı davet edin ve bonus puan kazanın! Her referans için 100 puan artı kazançlarının %10'unu alın.",
    startReferring: 'Referans etmeye başla',
    referralSuccess:
        '🎉 Tebrikler! Başarıyla kullanıcıları referans ettiniz ve bonus puan kazanıyorsunuz!',
    unranked: 'Sıralanmamış',
    noPlayersYet: 'İlk katılan siz olun!',
    shareVia: 'Paylaşım yolu',
    shareOn: '{{network}} üzerinde paylaş',
    shareInviteText:
        "🚀 @CoinomiWallet ile ücretsiz kripto para kazanıyorum!\n\ncoinomi.com/downloads adresinden Coinomi'yi indirin ve uygulamada #Coinomi Rewards'a katılırken bonus almak için benim referans kodumu {{referralCode}} girin.",
    player: 'Oyuncu',
    score: 'Puan',
    youHaveReferred_zero: 'Henüz hiç arkadaş davet etmediniz',
    youHaveReferred_one: '1 arkadaş davet ettiniz',
    youHaveReferred_other: '{{count}} arkadaş davet ettiniz',
    referYourFriends: 'Arkadaşlarını Davet Et',
    dailyRewardTooltip: 'Puanlarınızı ve ödüllerinizi almak için her gün geri gelin',
    weeklyRewardTooltip: 'Ödül dağıtımları haftalık olarak yapılır',
    copy: 'Kopyala',
    // Twitter Challenge
    twitterChallenge: 'Twitter Görevi',
    connectTwitter: 'Twitter ile Bağlan',
    twitterSuccess: '🎉 Tebrikler! Artık tüm ödüllerde %10 kalıcı bonus alıyorsunuz!',
    twitterPrompt: 'Twitter hesabınızı bağlayarak tüm ödüllerde %10 kalıcı bonus kazanın!',
    pleaseAddUserId: "Lütfen URL'ye userId parametresini ekleyin",
    emailChallengePrompt: 'Tüm ödüllerde kalıcı %10 bonus almak için e-postanızı paylaşın!',
    emailChallengeSuccess: '🎉 Bağlandı! Artık tüm ödüllerde kalıcı %10 bonus alıyorsunuz!',
    followKoalaWalletChallenge:
        "Bizi desteklemek için Twitter'da @coinomiWallet hesabını takip edin!",
    twitterAuthSuccessTitle: 'Twitter başarıyla bağlandı!',
    twitterAuthSuccessMessage:
        'Twitter hesabı başarıyla bağlandı. Artık uygulamayı kullanmaya devam edebilirsiniz.',
    continueToApp: 'Uygulamaya devam et',
    twitter_like: 'Tweeti beğendiniz',
    twitter_retweet: 'Tweeti retweetlediniz',
    disconnect: 'Bağlantıyı Kes',
    followCoinomiWallet: "Bizi desteklemek için Twitter'da @coinomiWallet hesabını takip edin!",
    connectedBonus: '🎉 Bağlandı! Artık tüm ödüllerde kalıcı %10 bonus alıyorsunuz!',
};
